import { connect } from 'react-redux';
import { handleFetchRegulatoryOrganizations } from '../../../actions/admin_actions';
import RegulatoryOrganizations from '../../../components/admin/riaContacts/RegulatoryOrganizations';

const mapStateToProps = (state) => {
  return {
    adminUserSession: state.adminLogin.adminUserSession,
    regulatoryOrganizations: state.regulatoryOrganizations.regulatoryOrganizations
  }
}

const RegulatoryOrganizationsContainer = connect(mapStateToProps, { handleFetchRegulatoryOrganizations })(RegulatoryOrganizations)

export default RegulatoryOrganizationsContainer;